import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const FAQ = ({ t }) => (
  <section id="faq" data-testid="faq-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-4xl px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7 }}
      >
        <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-[#EAB308]">{t.faq.eyebrow}</p>
        <h2 className="mt-4 text-4xl font-extrabold sm:text-5xl">{t.faq.headline}</h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="mt-12 rounded-2xl border border-white/10 bg-[#0C1732] px-8"
      >
        <Accordion type="single" collapsible>
          {t.faq.items.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-white/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-left font-['Outfit'] text-base font-semibold text-white transition-colors duration-200 hover:text-[#EAB308] hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-sm leading-relaxed text-gray-400">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
